import { combineReducers } from "redux";
import featureReducer from "./features/reducer";
import authReducer from "./auth/reducer";
import organizationReducer from "./organization/reducer";

export const rootReducer = combineReducers({
  feature: featureReducer,
  auth: authReducer,
  organization: organizationReducer,
});
